import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Custom loading button component that manages its own loading state
 * @param {Object} props - Component props
 * @param {boolean} props.loading - Whether the button is in loading state
 * @param {string} props.loadingText - Text to show while loading (default: "Loading...")
 * @param {string} props.children - Button text when not loading
 * @param {Object} props.buttonProps - Props to pass to the underlying MUI Button
 * @param {string} props.size - Size of the loading spinner (default: 20)
 */
const LoadingButton = ({ 
  loading = false, 
  loadingText = "Loading...", 
  children, 
  buttonProps = {}, 
  size = 20,
  ...rest 
}) => {
  return (
    <Button
      {...buttonProps}
      {...rest}
      disabled={loading || buttonProps.disabled}
      sx={{
        minWidth: '80px',
        position: 'relative',
        ...buttonProps.sx
      }}
    >
      {loading ? (
        <>
          <CircularProgress size={size} color="inherit" sx={{ mr: 1 }} />
          {loadingText}
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
